import { apiCall } from "@/api/axios";
import { useApiQuery } from "@/hooks/tanstack/use-api-query/useApiQuery";
import { BASE_ROUTE as NO_SHARE_AUTH_ROUTE } from "./_base_route";
import composeRoute from "../utils/route-utils/route-utils";

export const getShareAuth = async (token) => {
  return new Promise((resolve, reject) => {
    return apiCall({
      method: "get",
      url: composeRoute(`${NO_SHARE_AUTH_ROUTE}`, [token]),
      shouldRedirect: false,
    })
      .then(resolve)
      .catch(reject);
  });
};

export const useGetShareAuth = (enabled = true, token) => {
  return useApiQuery({
    enabled,
    queryFn: async () => await getShareAuth(token),
    queryKey: ["shareAuth", token || ""],
    initialData: [],
  });
};

export default useGetShareAuth;
